import React from 'react';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/qna-box.module.css';

export default function QnABox({ question, answer }) {
  const mobileSmall = useMediaQuery('(max-width: 480px)');

  return (
    <div className={styles.wrapper}>
        <div className={styles.container}>
            {mobileSmall ? null : <p className={styles.title01}>Q</p>}
            <div className={styles.answer01}>{question}</div>
        </div>
        <div className={styles.container}>
            {mobileSmall ? null : <p className={styles.title02}>A</p>}
            <div className={styles.answer}>{answer}</div>
        </div>
    </div>
  );
}
